import { getDeployEnv } from "./globals.mjs";
import { globalObservability } from "@opendoor/observability/slim";
import Cookies from "js-cookie";
//#region src/helpers/api.ts
var DEPLOY_ENV = getDeployEnv();
var XSRF_COOKIE_KEY = DEPLOY_ENV !== "development" ? "XSRF-G-TOKEN" : "XSRF-TOKEN";
var DEFAULT_LOCALDEV_ATHENA_URL = "http://localhost:4000/api/graphql";
var getWindowEnv = () => {
	if (typeof window === "undefined") return;
	return window.ENV;
};
var getLocaldevAthenaUrl = () => {
	const windowEnv = getWindowEnv();
	return windowEnv?.ODFE_ATHENA_URL || windowEnv?.REACT_APP_GRAPHQL_API_URL || typeof process !== "undefined" && process.env.ODFE_ATHENA_URL || typeof process !== "undefined" && process.env.REACT_APP_GRAPHQL_API_URL || DEFAULT_LOCALDEV_ATHENA_URL;
};
var ATHENA_URL = {
	production: "https://graphql.apps.opendoor.com/api/graphql",
	development: "https://graphql.simplersell.com/api/graphql",
	localdev: getLocaldevAthenaUrl(),
	qa: "https://graphql.simplersell.com/api/graphql",
	staging: "https://graphql.simplersell.com/api/graphql",
	test: "https://graphql.simplersell.com/api/graphql"
}[DEPLOY_ENV];
/**
* A wrapper around `fetch` with optional retries.
* Retries up to `options.retries` times (defaults to `5` if not specified)
* with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
*/
var fetchWithRetry = async (url, options) => {
	const retries = options.retries || 0;
	const retryDelay = options.retryDelay || 500;
	try {
		return await fetch(url, options);
	} catch (err) {
		if (retries < 1) throw err;
		await new Promise((r) => setTimeout(r, retryDelay));
		return await fetchWithRetry(url, {
			...options,
			retries: retries - 1
		});
	}
};
var Sentry = globalObservability.getSentryClient();
function handleResponse(res) {
	if (res.ok) return res.json();
	Sentry.withScope?.((scope) => {
		scope.setExtras({ resonse: res });
		Sentry.captureMessage?.("Non-200 response received in api call");
	});
}
function doBFFPost(apiUrl, jsonParams, options = {}) {
	return fetchWithRetry(apiUrl, {
		retries: 5,
		retryDelay: 500,
		credentials: "include",
		method: "POST",
		body: JSON.stringify(jsonParams),
		...options,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			"X-CSRF-Token": Cookies.get(XSRF_COOKIE_KEY) || "",
			...options.headers
		}
	});
}
function listUnits(addressUUID) {
	return doBFFPost(ATHENA_URL, {
		operationName: "ListUnits",
		query: `query ListUnits($addressUUID: String!, $limit: Float!) {
        casa {
          listUnits(input: { uuid: $addressUUID, limit: $limit }) {
            addresses{
              uuid
              result
            }
          }
        }
      }`,
		variables: {
			addressUUID,
			limit: 10
		}
	}, { headers: { "apollographql-client-name": "cinderblocks" } }).then(handleResponse).catch((e) => Sentry.captureException?.(e));
}
function standardizeAddress(address) {
	return doBFFPost(ATHENA_URL, {
		operationName: "StandardizeAddress",
		query: `query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {
      casa {
        findByFields(input: $address) {
          address {
            uuid
            street
            city
            state
            unitNumber
            unitType
            postalCode
            latitude
            longitude
            result
          }
        }
      }
    }`,
		variables: { address: {
			city: address.city,
			postalCode: address.postal_code,
			state: address.state,
			street: address.street1,
			unitNumber: address.unit
		} }
	}, { headers: { "apollographql-client-name": "cinderblocks" } }).then(handleResponse).catch((e) => Sentry.captureException?.(e));
}
function createMortgageLead(input) {
	return doBFFPost(ATHENA_URL, {
		operationName: "MortgageLead",
		query: `
    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {
      customerFinancingService {
        createMortgageLead(input: $input) {
          mortgageLead {
            mortgageLeadId
            customerUuid
          }
        }
      }
    }
  `,
		variables: { input: {
			customerUuid: input.customerUuid,
			channel: "CUSTOMER_EXPERIENCE",
			addressToken: input?.addressToken,
			propertyType: input.propertyType,
			targetMoveDate: input.targetMoveDate,
			targetPrice: input.targetPrice,
			targetDownPayment: input.targetDownPayment,
			targetLocation: input.targetLocation,
			employmentStatus: input.employmentStatus,
			householdIncomeMin: input.householdIncomeMin,
			householdIncomeMax: input.householdIncomeMax,
			firstName: input.firstName,
			lastName: input.lastName,
			phone: input.phone,
			email: input.email,
			currentAddress: input.currentAddress
		} }
	}, { headers: { "apollographql-client-name": "cinderblocks" } }).then(async (response) => {
		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(`GraphQL mutation failed: ${errorText}`);
		}
		const result = await response.json();
		if (result.errors) throw new Error(`GraphQL errors: ${JSON.stringify(result.errors)}`);
		return result;
	}).catch((e) => {
		Sentry.captureException?.(e);
		throw e;
	});
}
//#endregion
export { createMortgageLead, listUnits, standardizeAddress };

//# sourceMappingURL=api.mjs.map